var map = {
	"./MicroWaveOven.png": 2558,
	"./MicroWaveOvenActive.png": 1105,
	"./NewlyRenovatedActive.png": 5666,
	"./SeparateBathroomAndToilet.png": 5612,
	"./SeparateBathroomAndToiletActive.png": 9794,
	"./TrackingFunction.png": 976,
	"./TrackingFunctionActive.png": 9115,
	"./airConditioner.png": 7813,
	"./airConditionerActive.png": 1960,
	"./autoLock.png": 7754,
	"./autoLockActive.png": 6395,
	"./facingSouth.png": 1340,
	"./facingSouthActive.png": 1003,
	"./highFloor.png": 7805,
	"./highFloorActive.png": 5143,
	"./newlyRenovated.png": 3022,
	"./parkingLot.png": 1740,
	"./parkingLotActive.png": 5475,
	"./petConsultation.png": 2471,
	"./petConsultationActive.png": 7303,
	"./refrigerator.png": 7573,
	"./refrigeratorActive.png": 6730,
	"./tablesAndChairs.png": 9941,
	"./tablesAndChairsActive.png": 1179,
	"./washingMachine.png": 3910,
	"./washingMachineActive.png": 6402,
	"./woodenFloor.png": 2274,
	"./woodenFloorActive.png": 9834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6074;